// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalChangePassword__mVGUl {
  width: 696px;
  height: 510px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.bodyRtl___OJi5 {
  direction: rtl;
}

.modalBody__YxEsG {
  height: 100%;
  flex: 1;
  display: flex;
  padding: 25px 25px 0;
}

.cardBlock__wZOJG {
  width: 40%;
}

.cardItem__jy1v8 {
  min-height: 284px;
  max-height: 320px;
  max-width: 214px;
  padding: 15px 10px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--tables-primary-row-surface-default);
  border: 1px solid var(--tables-primary-row-stroke);
  border-radius: 5px;
}
@media (max-width: 850px) {
  .cardItem__jy1v8 {
    min-height: 245px;
  }
}

.cardItemIconWrapper__yd6om .cardItemIconDark__kGJse {
  height: 70px;
  width: 120px;
}
@media (max-width: 850px) {
  .cardItemIconWrapper__yd6om svg {
    height: 80px;
  }
}

.cardItemTitle__d41gz {
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  text-transform: uppercase;
  color: var(--tables-primary-row-text-main);
  margin-top: 25px;
  margin-bottom: 0;
  max-width: 180px;
  line-clamp: 2;
}
@media (max-width: 850px) {
  .cardItemTitle__d41gz {
    font-size: 14px;
    line-height: 16px;
    margin-top: 15px;
  }
}

.cardItemDescription__JYwLE {
  font-size: 10px;
  line-height: 16px;
  text-align: center;
  text-transform: inherit;
  color: var(--tables-secondary-row-sub-title-text);
  margin-top: 24px;
  margin-bottom: 0;
}
@media (max-width: 850px) {
  .cardItemDescription__JYwLE {
    margin-top: 12px;
  }
}

.profileChangePasswordForm__i1TjF {
  padding-top: 24px;
  padding-left: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 32px;
}

.eyeOffIcon__EfkAN {
  width: 24px;
  height: 18px;
  cursor: pointer;
}
.eyeOffIcon__EfkAN path:first-child,
.eyeOffIcon__EfkAN circle {
  stroke: var(--buttons-surface);
}
.eyeOffIcon__EfkAN path:last-child {
  fill: var(--buttons-surface);
}

.eyeIcon__mMeuM {
  width: 24px;
  height: 18px;
  cursor: pointer;
}
.eyeIcon__mMeuM circle {
  stroke: var(--buttons-surface);
}
.eyeIcon__mMeuM path {
  fill: var(--buttons-surface);
}

.modalFooter__R1ijL {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 25px;
  padding: 25px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/ChangePasswordModal/style.module.scss"],"names":[],"mappings":"AAgFA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AA/EF;;AAkFA;EACE,cAAA;AA/EF;;AAkFA;EACE,YAAA;EACA,OAAA;EACA,aAAA;EACA,oBAAA;AA/EF;;AAkFA;EACE,UAAA;AA/EF;;AAkFA;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,qDAAA;EACA,kDAAA;EACA,kBAAA;AA/EF;AAiFE;EAZF;IAaI,iBAAA;EA9EF;AACF;;AAkFE;EACE,YAAA;EACA,YAAA;AA/EJ;AAkFE;EACE;IACE,YAAA;EAhFJ;AACF;;AAoFA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,0CAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AAjFF;AAkFE;EAZF;IAaI,eAAA;IACA,iBAAA;IACA,gBAAA;EA/EF;AACF;;AAkFA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,iDAAA;EACA,gBAAA;EACA,gBAAA;AA/EF;AAgFE;EARF;IASI,gBAAA;EA7EF;AACF;;AAgFA;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AA7EF;;AAgFA;EAnGE,WAAA;EACA,YAAA;EACA,eAAA;AAuBF;AA2EE;;EAEE,8BAAA;AAzEJ;AA2EE;EACE,4BAAA;AAzEJ;;AA+EA;EA/GE,WAAA;EACA,YAAA;EACA,eAAA;AAoCF;AA0EE;EACE,8BAAA;AAxEJ;AA0EE;EACE,4BAAA;AAxEJ;;AA8EA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AA3EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n@mixin eyeIcon {\n  width: 24px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.modalChangePassword {\n  width: 696px;\n  height: 510px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.bodyRtl {\n  direction: rtl;\n}\n\n.modalBody {\n  height: 100%;\n  flex: 1;\n  display: flex;\n  padding: 25px 25px 0;\n}\n\n.cardBlock {\n  width: 40%;\n}\n\n.cardItem {\n  min-height: 284px;\n  max-height: 320px;\n  max-width: 214px;\n  padding: 15px 10px 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: var(--tables-primary-row-surface-default);\n  border: 1px solid var(--tables-primary-row-stroke);\n  border-radius: 5px;\n\n  @media (max-width: 850px) {\n    min-height: 245px;\n  }\n}\n\n.cardItemIconWrapper {\n  .cardItemIconDark {\n    height: 70px;\n    width: 120px;\n  }\n\n  @media (max-width: 850px) {\n    svg {\n      height: 80px;\n    }\n  }\n}\n\n.cardItemTitle {\n  font-family: 'Roboto', sans-serif;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 20px;\n  text-align: center;\n  text-transform: uppercase;\n  color: var(--tables-primary-row-text-main);\n  margin-top: 25px;\n  margin-bottom: 0;\n  max-width: 180px;\n  line-clamp: 2;\n  @media (max-width: 850px) {\n    font-size: 14px;\n    line-height: 16px;\n    margin-top: 15px;\n  }\n}\n\n.cardItemDescription {\n  font-size: 10px;\n  line-height: 16px;\n  text-align: center;\n  text-transform: inherit;\n  color: var(--tables-secondary-row-sub-title-text);\n  margin-top: 24px;\n  margin-bottom: 0;\n  @media (max-width: 850px) {\n    margin-top: 12px;\n  }\n}\n\n.profileChangePasswordForm {\n  padding-top: 24px;\n  padding-left: 24px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  row-gap: 32px;\n}\n\n.eyeOffIcon {\n  path:first-child,\n  circle {\n    stroke: var(--buttons-surface);\n  }\n  path:last-child {\n    fill: var(--buttons-surface);\n  }\n\n  @include eyeIcon;\n}\n\n.eyeIcon {\n  circle {\n    stroke: var(--buttons-surface);\n  }\n  path {\n    fill: var(--buttons-surface);\n  }\n\n  @include eyeIcon;\n}\n\n.modalFooter {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  column-gap: 25px;\n  padding: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalChangePassword": `modalChangePassword__mVGUl`,
	"bodyRtl": `bodyRtl___OJi5`,
	"modalBody": `modalBody__YxEsG`,
	"cardBlock": `cardBlock__wZOJG`,
	"cardItem": `cardItem__jy1v8`,
	"cardItemIconWrapper": `cardItemIconWrapper__yd6om`,
	"cardItemIconDark": `cardItemIconDark__kGJse`,
	"cardItemTitle": `cardItemTitle__d41gz`,
	"cardItemDescription": `cardItemDescription__JYwLE`,
	"profileChangePasswordForm": `profileChangePasswordForm__i1TjF`,
	"eyeOffIcon": `eyeOffIcon__EfkAN`,
	"eyeIcon": `eyeIcon__mMeuM`,
	"modalFooter": `modalFooter__R1ijL`
};
module.exports = ___CSS_LOADER_EXPORT___;
